import customCurrencyListOfAtomFamily from './atomFamily';

export default customCurrencyListOfAtomFamily;
